import { PAGE_PATH } from '@/constants';
import parseHtml from './parseHtml';

export default {
  /**
   * 页面返回
   * @returns
   */
  back: (customFn?: Function) => {
    const pages = getCurrentPages();
    if (pages.length === 1) {
      if (customFn) {
        customFn();
      } else {
        uni.reLaunch({ url: PAGE_PATH.home.route });
      }
      return;
    }
    uni.navigateBack();
  },
  parseHtml,
};
